export const products = [
  // Women (5)
  {
    id: "1",
    name: "Women's Classic Fit Cotton T-Shirt",
    brand: "Style & Co",
    category: "Women",
    price: 29.5,
    salePrice: 19.99,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400",
    rating: 4.5,
    reviews: 1243,
    description: "Soft cotton t-shirt with a classic fit. Perfect for everyday wear.",
    sizes: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "2",
    name: "Women's Wool Blend Peacoat",
    brand: "Calvin Klein",
    category: "Women",
    price: 225.0,
    salePrice: 159.99,
    image: "https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=400",
    rating: 4.5,
    reviews: 654,
    description: "Classic wool blend peacoat with double-breasted front.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "3",
    name: "Floral Midi Wrap Dress",
    brand: "INC International Concepts",
    category: "Women",
    price: 89.5,
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400",
    rating: 4.6,
    reviews: 412,
    description: "Lightweight wrap dress with a flattering silhouette.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [
      { name: "Navy Floral", hex: "#1a237e" },
      { name: "Rose", hex: "#c2185b" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "4",
    name: "High-Rise Skinny Jeans",
    brand: "Levi's",
    category: "Women",
    price: 79.5,
    salePrice: 59.99,
    image: "https://images.unsplash.com/photo-1582418702059-97ebafb35d09?w=400",
    rating: 4.7,
    reviews: 2102,
    description: "Stretch denim with a high-rise waist and skinny leg.",
    sizes: ["24", "26", "28", "30", "32"],
    colors: [
      { name: "Blue", hex: "#3949ab" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "5",
    name: "Cashmere Crewneck Sweater",
    brand: "Charter Club",
    category: "Women",
    price: 129.0,
    image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400",
    rating: 4.8,
    reviews: 891,
    description: "Luxuriously soft cashmere blend crewneck.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [
      { name: "Camel", hex: "#c19a6b" },
      { name: "Gray", hex: "#757575" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Men (5)
  {
    id: "6",
    name: "Men's Slim Fit Stretch Jeans",
    brand: "Levi's",
    category: "Men",
    price: 69.5,
    salePrice: 49.99,
    image: "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400",
    rating: 4.7,
    reviews: 856,
    description: "Classic slim fit jeans with stretch comfort.",
    sizes: ["28", "30", "32", "34", "36", "38"],
    colors: [
      { name: "Dark Wash", hex: "#1a237e" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "7",
    name: "Men's Oxford Dress Shirt",
    brand: "Tommy Hilfiger",
    category: "Men",
    price: 69.5,
    image: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400",
    rating: 4.5,
    reviews: 723,
    description: "Crisp cotton oxford with button-down collar.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Light Blue", hex: "#90caf9" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "8",
    name: "Men's Quilted Bomber Jacket",
    brand: "Michael Kors",
    category: "Men",
    price: 198.0,
    salePrice: 149.99,
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400",
    rating: 4.6,
    reviews: 334,
    description: "Lightweight quilted bomber with zip front.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "9",
    name: "Men's Chino Shorts",
    brand: "Club Room",
    category: "Men",
    price: 49.5,
    image: "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?w=400",
    rating: 4.4,
    reviews: 567,
    description: "Classic fit chino shorts with stretch waistband.",
    sizes: ["30", "32", "34", "36", "38"],
    colors: [
      { name: "Khaki", hex: "#c2b280" },
      { name: "Navy", hex: "#0d47a1" },
    ],
    inStock: true,
  },
  {
    id: "10",
    name: "Men's Fleece Pullover Hoodie",
    brand: "Nike",
    category: "Men",
    price: 65.0,
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400",
    rating: 4.8,
    reviews: 1520,
    description: "Soft fleece hoodie with kangaroo pocket.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "Gray", hex: "#9E9E9E" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Kids (5)
  {
    id: "11",
    name: "Kids' Graphic Print Hoodie",
    brand: "Nike",
    category: "Kids",
    price: 45.0,
    image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400",
    rating: 4.8,
    reviews: 432,
    description: "Comfortable cotton blend hoodie with fun graphic print.",
    sizes: ["4", "5", "6", "7", "8", "10", "12"],
    colors: [
      { name: "Gray", hex: "#9E9E9E" },
      { name: "Pink", hex: "#E91E63" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "12",
    name: "Girls' Tulle Party Dress",
    brand: "Rare Editions",
    category: "Kids",
    price: 58.0,
    salePrice: 39.99,
    image: "https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=400",
    rating: 4.7,
    reviews: 289,
    description: "Sparkly tulle dress perfect for parties and photos.",
    sizes: ["4", "5", "6", "7", "8", "10"],
    colors: [{ name: "Blush", hex: "#f8bbd0" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "13",
    name: "Boys' Cargo Jogger Pants",
    brand: "Epic Threads",
    category: "Kids",
    price: 36.0,
    image: "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=400",
    rating: 4.5,
    reviews: 178,
    description: "Durable joggers with cargo pockets and elastic cuffs.",
    sizes: ["4", "5", "6", "7", "8", "10", "12", "14"],
    colors: [
      { name: "Olive", hex: "#558b2f" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
  },
  {
    id: "14",
    name: "Kids' Light-Up Sneakers",
    brand: "Skechers",
    category: "Kids",
    price: 54.0,
    image: "https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=400",
    rating: 4.6,
    reviews: 901,
    description: "Fun light-up soles with easy hook-and-loop closure.",
    sizes: ["11", "12", "13", "1", "2", "3"],
    colors: [
      { name: "Blue/Red", hex: "#1565c0" },
      { name: "Pink", hex: "#e91e63" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "15",
    name: "Baby 5-Piece Bodysuit Set",
    brand: "First Impressions",
    category: "Kids",
    price: 32.0,
    image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400",
    rating: 4.9,
    reviews: 1204,
    description: "Soft cotton bodysuits with snap closures.",
    sizes: ["0-3M", "3-6M", "6-9M", "9-12M"],
    colors: [{ name: "Assorted", hex: "#eceff1" }],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Home (5)
  {
    id: "16",
    name: "Luxury Queen Sheet Set",
    brand: "Hotel Collection",
    category: "Home",
    price: 189.0,
    salePrice: 129.99,
    image: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400",
    rating: 4.6,
    reviews: 2103,
    description: "600-thread count Egyptian cotton sheet set.",
    sizes: ["Twin", "Full", "Queen", "King"],
    colors: [{ name: "White", hex: "#FFFFFF" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "17",
    name: "Martha Stewart Dutch Oven",
    brand: "Martha Stewart",
    category: "Home",
    price: 149.99,
    image: "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=400",
    rating: 4.8,
    reviews: 756,
    description: "Enameled cast iron 5.5-qt Dutch oven.",
    sizes: ["One Size"],
    colors: [
      { name: "Red", hex: "#c62828" },
      { name: "Blue", hex: "#1565c0" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "18",
    name: "Velvet Throw Pillow Set (2-Pack)",
    brand: "Lacoste",
    category: "Home",
    price: 48.0,
    image: "https://images.unsplash.com/photo-1629949009765-40fc74c9ec21?w=400",
    rating: 4.4,
    reviews: 445,
    description: "Plush velvet covers with feather inserts.",
    sizes: ["18x18", "20x20"],
    colors: [
      { name: "Emerald", hex: "#2e7d32" },
      { name: "Gold", hex: "#f9a825" },
    ],
    inStock: true,
  },
  {
    id: "19",
    name: "Spa Waffle Towel Bundle",
    brand: "Hotel Collection",
    category: "Home",
    price: 79.5,
    salePrice: 59.99,
    image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400",
    rating: 4.7,
    reviews: 623,
    description: "Six-piece towel set in quick-dry waffle weave.",
    sizes: ["Bath", "Hand", "Wash"],
    colors: [{ name: "White", hex: "#FFFFFF" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "20",
    name: "Modern Ceramic Table Lamp",
    brand: "Safavieh",
    category: "Home",
    price: 89.0,
    image: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?w=400",
    rating: 4.5,
    reviews: 312,
    description: "Matte ceramic base with linen drum shade.",
    sizes: ["One Size"],
    colors: [
      { name: "White", hex: "#fafafa" },
      { name: "Black", hex: "#212121" },
    ],
    inStock: true,
  },

  // Shoes (5)
  {
    id: "21",
    name: "Air Max Running Sneakers",
    brand: "Nike",
    category: "Shoes",
    price: 160.0,
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400",
    rating: 4.9,
    reviews: 3421,
    description: "Premium running sneakers with Air Max cushioning.",
    sizes: ["6", "7", "8", "9", "10", "11", "12"],
    colors: [{ name: "Black/White", hex: "#000000" }],
    inStock: true,
    badge: "BEST SELLER",
  },
  {
    id: "22",
    name: "Men's Leather Oxford Shoes",
    brand: "Cole Haan",
    category: "Shoes",
    price: 198.0,
    salePrice: 149.99,
    image: "https://images.unsplash.com/photo-1614252235316-8c857d38b5f4?w=400",
    rating: 4.7,
    reviews: 432,
    description: "Genuine leather oxford shoes with cushioned insole.",
    sizes: ["7", "8", "9", "10", "11", "12"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "23",
    name: "Women's Block Heel Sandals",
    brand: "INC International Concepts",
    category: "Shoes",
    price: 79.5,
    image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=400",
    rating: 4.5,
    reviews: 887,
    description: "Comfortable block heel with ankle strap.",
    sizes: ["5", "6", "7", "8", "9", "10"],
    colors: [
      { name: "Nude", hex: "#d7ccc8" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
  },
  {
    id: "24",
    name: "Adidas Ultraboost Running",
    brand: "adidas",
    category: "Shoes",
    price: 190.0,
    salePrice: 159.99,
    image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=400",
    rating: 4.8,
    reviews: 2789,
    description: "Responsive Boost midsole with Primeknit upper.",
    sizes: ["6", "7", "8", "9", "10", "11", "12"],
    colors: [
      { name: "Core Black", hex: "#000000" },
      { name: "White", hex: "#FFFFFF" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "25",
    name: "UGG Classic Mini Boots",
    brand: "UGG",
    category: "Shoes",
    price: 170.0,
    image: "https://images.unsplash.com/photo-1608256246200-53e635b5b65f?w=400",
    rating: 4.9,
    reviews: 4102,
    description: "Sheepskin lining with durable outsole.",
    sizes: ["5", "6", "7", "8", "9", "10", "11"],
    colors: [
      { name: "Chestnut", hex: "#8d6e63" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Handbags (5)
  {
    id: "26",
    name: "Leather Crossbody Bag",
    brand: "Michael Kors",
    category: "Handbags",
    price: 298.0,
    salePrice: 199.99,
    image: "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400",
    rating: 4.7,
    reviews: 876,
    description: "Genuine leather crossbody bag with adjustable strap.",
    sizes: ["One Size"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "27",
    name: "Large Leather Tote",
    brand: "Coach",
    category: "Handbags",
    price: 395.0,
    image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=400",
    rating: 4.8,
    reviews: 543,
    description: "Roomy tote with zip top and interior pockets.",
    sizes: ["One Size"],
    colors: [
      { name: "Brown", hex: "#5d4037" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "28",
    name: "Quilted Chain Shoulder Bag",
    brand: "Guess",
    category: "Handbags",
    price: 98.0,
    salePrice: 74.99,
    image: "https://images.unsplash.com/photo-1566150905458-1bf1fc113f0d?w=400",
    rating: 4.4,
    reviews: 421,
    description: "Quilted faux leather with gold-tone chain strap.",
    sizes: ["One Size"],
    colors: [{ name: "Black", hex: "#000000" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "29",
    name: "Straw Summer Clutch",
    brand: "INC International Concepts",
    category: "Handbags",
    price: 49.5,
    image: "https://images.unsplash.com/photo-1594223274512-ad4803739b7c?w=400",
    rating: 4.3,
    reviews: 198,
    description: "Woven straw clutch with magnetic closure.",
    sizes: ["One Size"],
    colors: [{ name: "Natural", hex: "#d7ccc8" }],
    inStock: true,
  },
  {
    id: "30",
    name: "Mini Backpack Purse",
    brand: "Steve Madden",
    category: "Handbags",
    price: 78.0,
    image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400",
    rating: 4.6,
    reviews: 667,
    description: "Convertible mini backpack with top handle.",
    sizes: ["One Size"],
    colors: [
      { name: "Blush", hex: "#f48fb1" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "NEW",
  },

  // Jewelry (5)
  {
    id: "31",
    name: "Diamond Pendant Necklace",
    brand: "Kay Jewelers",
    category: "Jewelry",
    price: 499.0,
    salePrice: 349.99,
    image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400",
    rating: 4.8,
    reviews: 543,
    description: "14K white gold diamond pendant necklace.",
    sizes: ["One Size"],
    colors: [{ name: "White Gold", hex: "#E8E8E8" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "32",
    name: "Gold Hoop Earrings",
    brand: "Macy's",
    category: "Jewelry",
    price: 125.0,
    image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400",
    rating: 4.6,
    reviews: 892,
    description: "14K yellow gold medium hoops with snap closure.",
    sizes: ["25mm", "35mm"],
    colors: [{ name: "Yellow Gold", hex: "#ffd54f" }],
    inStock: true,
  },
  {
    id: "33",
    name: "Sterling Silver Tennis Bracelet",
    brand: "Giani Bernini",
    category: "Jewelry",
    price: 89.0,
    salePrice: 69.99,
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400",
    rating: 4.5,
    reviews: 334,
    description: "Cubic zirconia line bracelet in sterling silver.",
    sizes: ["7 in", "7.5 in", "8 in"],
    colors: [{ name: "Silver", hex: "#b0bec5" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "34",
    name: "Men's Signet Ring",
    brand: "Esquire Men's Jewelry",
    category: "Jewelry",
    price: 199.0,
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400",
    rating: 4.4,
    reviews: 156,
    description: "Stainless steel signet ring with brushed finish.",
    sizes: ["9", "10", "11", "12"],
    colors: [{ name: "Silver", hex: "#90a4ae" }],
    inStock: true,
  },
  {
    id: "35",
    name: "Pearl Strand Necklace",
    brand: "Belle de Mer",
    category: "Jewelry",
    price: 275.0,
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=400",
    rating: 4.7,
    reviews: 278,
    description: "Cultured freshwater pearls with 14K gold clasp.",
    sizes: ["16 in", "18 in"],
    colors: [{ name: "White Pearl", hex: "#fffde7" }],
    inStock: true,
    badge: "NEW",
  },

  // Beauty (5)
  {
    id: "36",
    name: "Vitamin C Brightening Serum",
    brand: "Clinique",
    category: "Beauty",
    price: 62.0,
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400",
    rating: 4.6,
    reviews: 1876,
    description: "Potent vitamin C serum that brightens skin tone.",
    sizes: ["30ml", "50ml"],
    colors: [],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "37",
    name: "MAC Matte Lipstick",
    brand: "MAC",
    category: "Beauty",
    price: 22.0,
    image: "https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=400",
    rating: 4.8,
    reviews: 4521,
    description: "Iconic creamy matte lipstick, long-wearing.",
    sizes: ["One Size"],
    colors: [
      { name: "Ruby Woo", hex: "#b71c1c" },
      { name: "Velvet Teddy", hex: "#8d6e63" },
    ],
    inStock: true,
    badge: "BEST SELLER",
  },
  {
    id: "38",
    name: "Estée Lauder Advanced Night Repair",
    brand: "Estée Lauder",
    category: "Beauty",
    price: 105.0,
    salePrice: 89.99,
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400",
    rating: 4.9,
    reviews: 3201,
    description: "Night serum for visible renewal and hydration.",
    sizes: ["30ml", "50ml", "75ml"],
    colors: [],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "39",
    name: "Jo Malone Wood Sage & Sea Salt Cologne",
    brand: "Jo Malone London",
    category: "Beauty",
    price: 152.0,
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=400",
    rating: 4.7,
    reviews: 1123,
    description: "Earthy, mineral cologne in signature bottle.",
    sizes: ["30ml", "100ml"],
    colors: [],
    inStock: true,
  },
  {
    id: "40",
    name: "Olaplex Hair Perfector No.3",
    brand: "Olaplex",
    category: "Beauty",
    price: 30.0,
    image: "https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=400",
    rating: 4.8,
    reviews: 2890,
    description: "At-home treatment to reduce breakage.",
    sizes: ["100ml"],
    colors: [],
    inStock: true,
    badge: "BEST SELLER",
  },

  // Women (+5)
  {
    id: "41",
    name: "Ribbed Knit Tank Top",
    brand: "Style & Co",
    category: "Women",
    price: 24.5,
    image: "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=400",
    rating: 4.4,
    reviews: 312,
    description: "Soft ribbed knit tank—perfect for layering or wearing solo.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
  },
  {
    id: "42",
    name: "Wide-Leg Linen Blend Pants",
    brand: "INC International Concepts",
    category: "Women",
    price: 79.5,
    salePrice: 59.99,
    image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=400",
    rating: 4.6,
    reviews: 428,
    description: "Breathable linen blend with a relaxed wide leg and high waist.",
    sizes: ["0", "2", "4", "6", "8", "10", "12"],
    colors: [
      { name: "Natural", hex: "#d7ccc8" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "43",
    name: "Canvas Shopper Tote",
    brand: "Sunrise Style",
    category: "Women",
    price: 49.0,
    image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400",
    rating: 4.5,
    reviews: 267,
    description: "Roomy canvas tote with reinforced handles for everyday errands.",
    sizes: ["One Size"],
    colors: [
      { name: "Natural", hex: "#efebe9" },
      { name: "Navy", hex: "#1a237e" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "44",
    name: "Satin Button-Front Blouse",
    brand: "Charter Club",
    category: "Women",
    price: 59.5,
    image: "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=400",
    rating: 4.7,
    reviews: 551,
    description: "Lightweight satin blouse with a flattering relaxed fit.",
    sizes: ["XS", "S", "M", "L", "XL"],
    colors: [
      { name: "Ivory", hex: "#fffde7" },
      { name: "Blush", hex: "#f48fb1" },
    ],
    inStock: true,
  },
  {
    id: "45",
    name: "Leather Belt with Gold Buckle",
    brand: "Michael Kors",
    category: "Women",
    price: 48.0,
    image: "https://images.unsplash.com/photo-1475180098004-ca77a66827be?w=400",
    rating: 4.3,
    reviews: 189,
    description: "Smooth leather belt with polished hardware.",
    sizes: ["S", "M", "L"],
    colors: [
      { name: "Black", hex: "#000000" },
      { name: "Brown", hex: "#5d4037" },
    ],
    inStock: true,
  },

  // Men (+5)
  {
    id: "46",
    name: "Merino Wool Crew Sweater",
    brand: "Club Room",
    category: "Men",
    price: 79.5,
    salePrice: 64.99,
    image: "https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=400",
    rating: 4.6,
    reviews: 334,
    description: "Fine merino wool crewneck—perfect for office or weekend.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "Navy", hex: "#0d47a1" },
      { name: "Gray", hex: "#607d8b" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "47",
    name: "Classic Fit Polo Shirt",
    brand: "Tommy Hilfiger",
    category: "Men",
    price: 59.5,
    image: "https://images.unsplash.com/photo-1503341504253-dff4815485f1?w=400",
    rating: 4.5,
    reviews: 712,
    description: "Pique cotton polo with signature collar and chest logo.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Navy", hex: "#1a237e" },
    ],
    inStock: true,
  },
  {
    id: "48",
    name: "Retro Leather Sneakers",
    brand: "Cole Haan",
    category: "Men",
    price: 168.0,
    image: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=400",
    rating: 4.8,
    reviews: 445,
    description: "Heritage-inspired sneakers with cushioned footbed.",
    sizes: ["7", "8", "9", "10", "11", "12"],
    colors: [{ name: "White/Navy", hex: "#eceff1" }],
    inStock: true,
    badge: "BEST SELLER",
  },
  {
    id: "49",
    name: "Water-Repellent Windbreaker",
    brand: "Nike",
    category: "Men",
    price: 120.0,
    image: "https://images.unsplash.com/photo-1618220179428-22790b461013?w=400",
    rating: 4.7,
    reviews: 521,
    description: "Lightweight shell with hood and zip pockets.",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: [
      { name: "Black", hex: "#000000" },
      { name: "Olive", hex: "#558b2f" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "50",
    name: "Relaxed Taper Denim Jeans",
    brand: "Levi's",
    category: "Men",
    price: 79.5,
    image: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=400",
    rating: 4.6,
    reviews: 892,
    description: "Comfort stretch denim with a modern tapered leg.",
    sizes: ["28", "30", "32", "34", "36", "38"],
    colors: [
      { name: "Medium Wash", hex: "#5c6bc0" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
  },

  // Kids (+5)
  {
    id: "51",
    name: "Kids' Mesh Athletic Sneakers",
    brand: "Nike",
    category: "Kids",
    price: 52.0,
    image: "https://images.unsplash.com/photo-1586363104862-3a5e2ab60d99?w=400",
    rating: 4.7,
    reviews: 612,
    description: "Breathable mesh upper with cushioned sole for all-day play.",
    sizes: ["11", "12", "13", "1", "2", "3"],
    colors: [
      { name: "Black/White", hex: "#424242" },
      { name: "Pink", hex: "#e91e63" },
    ],
    inStock: true,
  },
  {
    id: "52",
    name: "STEM Building Brick Set (250 pcs)",
    brand: "Discovery Kids",
    category: "Kids",
    price: 34.99,
    salePrice: 27.99,
    image: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=400",
    rating: 4.9,
    reviews: 1204,
    description: "Colorful bricks for creative builds—includes storage tub.",
    sizes: ["One Size"],
    colors: [{ name: "Multi", hex: "#ff7043" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "53",
    name: "Kids' Striped Beanie & Glove Set",
    brand: "First Impressions",
    category: "Kids",
    price: 22.0,
    image: "https://images.unsplash.com/photo-1582735689369-4fe89db7114c?w=400",
    rating: 4.5,
    reviews: 178,
    description: "Soft knit beanie and gloves with playful stripes.",
    sizes: ["S/M", "L/XL"],
    colors: [
      { name: "Rainbow", hex: "#7e57c2" },
      { name: "Navy", hex: "#283593" },
    ],
    inStock: true,
  },
  {
    id: "54",
    name: "Foldable Kids' Play Mat",
    brand: "Baby Essentials",
    category: "Kids",
    price: 44.0,
    image: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?w=400",
    rating: 4.6,
    reviews: 423,
    description: "Padded foam mat—easy to fold and store.",
    sizes: ["One Size"],
    colors: [{ name: "Pastel", hex: "#b2dfdb" }],
    inStock: true,
  },
  {
    id: "55",
    name: "Teen Lounge Accent Chair",
    brand: "Novogratz",
    category: "Kids",
    price: 129.0,
    salePrice: 99.99,
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400",
    rating: 4.4,
    reviews: 156,
    description: "Compact accent chair—great for bedrooms and hangout spaces.",
    sizes: ["One Size"],
    colors: [
      { name: "Yellow", hex: "#fdd835" },
      { name: "Gray", hex: "#78909c" },
    ],
    inStock: true,
    badge: "SALE",
  },

  // Home (+5)
  {
    id: "56",
    name: "Mid-Century Accent Armchair",
    brand: "Safavieh",
    category: "Home",
    price: 449.0,
    salePrice: 379.99,
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400",
    rating: 4.7,
    reviews: 289,
    description: "Walnut legs with textured upholstery—statement seating for any room.",
    sizes: ["One Size"],
    colors: [
      { name: "Mustard", hex: "#f9a825" },
      { name: "Teal", hex: "#00897b" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "57",
    name: "12-Piece Stainless Cookware Set",
    brand: "Martha Stewart",
    category: "Home",
    price: 199.99,
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400",
    rating: 4.8,
    reviews: 1567,
    description: "Even-heating stainless steel with glass lids.",
    sizes: ["One Size"],
    colors: [{ name: "Silver", hex: "#90a4ae" }],
    inStock: true,
    badge: "BEST SELLER",
  },
  {
    id: "58",
    name: "Artisan Stoneware Dinner Plates (Set of 4)",
    brand: "Hotel Collection",
    category: "Home",
    price: 56.0,
    image: "https://images.unsplash.com/photo-1493666438817-866a91353ca9?w=400",
    rating: 4.5,
    reviews: 334,
    description: "Reactive glaze stoneware—microwave and dishwasher safe.",
    sizes: ["One Size"],
    colors: [
      { name: "Speckled Blue", hex: "#546e7a" },
      { name: "Sand", hex: "#d7ccc8" },
    ],
    inStock: true,
  },
  {
    id: "59",
    name: "Scented Soy Candle Trio",
    brand: "Lafco",
    category: "Home",
    price: 42.0,
    image: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=400",
    rating: 4.6,
    reviews: 892,
    description: "Three complementary fragrances in gift-ready packaging.",
    sizes: ["One Size"],
    colors: [{ name: "Assorted", hex: "#ffcc80" }],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "60",
    name: "Adjustable Architect Desk Lamp",
    brand: "Simple Designs",
    category: "Home",
    price: 64.5,
    image: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=400",
    rating: 4.4,
    reviews: 267,
    description: "Metal swing-arm lamp with integrated USB port.",
    sizes: ["One Size"],
    colors: [
      { name: "Black", hex: "#212121" },
      { name: "Brass", hex: "#ffb300" },
    ],
    inStock: true,
  },

  // Shoes (+5)
  {
    id: "61",
    name: "Court Classic Leather Sneakers",
    brand: "Adidas",
    category: "Shoes",
    price: 85.0,
    image: "https://images.unsplash.com/photo-1560769629-975ec94e6a86?w=400",
    rating: 4.7,
    reviews: 2134,
    description: "Clean leather upper with cushioned midsole.",
    sizes: ["6", "7", "8", "9", "10", "11"],
    colors: [
      { name: "White", hex: "#fafafa" },
      { name: "Navy", hex: "#1565c0" },
    ],
    inStock: true,
  },
  {
    id: "62",
    name: "Retro Runner Sneakers",
    brand: "New Balance",
    category: "Shoes",
    price: 110.0,
    salePrice: 89.99,
    image: "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400",
    rating: 4.8,
    reviews: 3421,
    description: "Heritage mesh-and-suede runner with supportive cushioning.",
    sizes: ["6", "7", "8", "9", "10", "11", "12"],
    colors: [{ name: "Gray/White", hex: "#9e9e9e" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "63",
    name: "Minimal Leather Slip-Ons",
    brand: "Vans",
    category: "Shoes",
    price: 65.0,
    image: "https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=400",
    rating: 4.6,
    reviews: 1876,
    description: "Easy slip-on silhouette with durable waffle sole.",
    sizes: ["6", "7", "8", "9", "10", "11"],
    colors: [
      { name: "Black", hex: "#000000" },
      { name: "White", hex: "#FFFFFF" },
    ],
    inStock: true,
  },
  {
    id: "64",
    name: "Trail Grip Hiking Sneakers",
    brand: "Columbia",
    category: "Shoes",
    price: 125.0,
    image: "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=400",
    rating: 4.7,
    reviews: 623,
    description: "Rugged outsole with breathable mesh upper.",
    sizes: ["7", "8", "9", "10", "11", "12"],
    colors: [{ name: "Black/Red", hex: "#37474f" }],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "65",
    name: "Sport Slide Sandals",
    brand: "adidas",
    category: "Shoes",
    price: 35.0,
    image: "https://images.unsplash.com/photo-1605348532760-6753d2c43329?w=400",
    rating: 4.5,
    reviews: 3422,
    description: "Contoured footbed slides—pool and locker-room ready.",
    sizes: ["6", "7", "8", "9", "10", "11"],
    colors: [
      { name: "Black", hex: "#000000" },
      { name: "White", hex: "#eeeeee" },
    ],
    inStock: true,
  },

  // Handbags (+5)
  {
    id: "66",
    name: "Studio Leather Satchel",
    brand: "Coach",
    category: "Handbags",
    price: 398.0,
    salePrice: 319.99,
    image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=400",
    rating: 4.8,
    reviews: 467,
    description: "Structured leather satchel with detachable shoulder strap.",
    sizes: ["One Size"],
    colors: [
      { name: "Saddle", hex: "#8d6e63" },
      { name: "Black", hex: "#000000" },
    ],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "67",
    name: "Carryall Canvas Weekender",
    brand: "INC International Concepts",
    category: "Handbags",
    price: 98.0,
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400",
    rating: 4.5,
    reviews: 312,
    description: "Spacious weekender with reinforced bottom and shoulder strap.",
    sizes: ["One Size"],
    colors: [{ name: "Natural", hex: "#efebe9" }],
    inStock: true,
  },
  {
    id: "68",
    name: "Zip-Around Leather Wallet",
    brand: "Michael Kors",
    category: "Handbags",
    price: 128.0,
    image: "https://images.unsplash.com/photo-1632345031435-8727f6897d53?w=400",
    rating: 4.7,
    reviews: 891,
    description: "RFID-blocking interior with multiple card slots.",
    sizes: ["One Size"],
    colors: [
      { name: "Black", hex: "#000000" },
      { name: "Blush", hex: "#f48fb1" },
    ],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "69",
    name: "Woven Straw Market Bag",
    brand: "Style & Co",
    category: "Handbags",
    price: 54.5,
    image: "https://images.unsplash.com/photo-1544816155-12df9643f363?w=400",
    rating: 4.4,
    reviews: 223,
    description: "Lightweight woven tote—perfect for weekends and travel.",
    sizes: ["One Size"],
    colors: [{ name: "Natural", hex: "#d7ccc8" }],
    inStock: true,
  },
  {
    id: "70",
    name: "Compact Leather Crossbody",
    brand: "Kate Spade New York",
    category: "Handbags",
    price: 228.0,
    salePrice: 179.99,
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400",
    rating: 4.8,
    reviews: 651,
    description: "Streamlined crossbody with adjustable strap and gold hardware.",
    sizes: ["One Size"],
    colors: [
      { name: "Black", hex: "#000000" },
      { name: "Warm Taupe", hex: "#a1887f" },
    ],
    inStock: true,
    badge: "SALE",
  },

  // Jewelry (+5)
  {
    id: "71",
    name: "Modern Stainless Steel Watch",
    brand: "Citizen",
    category: "Jewelry",
    price: 275.0,
    image: "https://images.unsplash.com/photo-1615729947596-a598e5de0ab3?w=400",
    rating: 4.7,
    reviews: 534,
    description: "Slim profile with mineral crystal and date window.",
    sizes: ["One Size"],
    colors: [{ name: "Silver", hex: "#cfd8dc" }],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "72",
    name: "Sterling Silver Stackable Rings (Set of 3)",
    brand: "Giani Bernini",
    category: "Jewelry",
    price: 48.0,
    salePrice: 39.99,
    image: "https://images.unsplash.com/photo-1526045612212-70caf35c14df?w=400",
    rating: 4.6,
    reviews: 412,
    description: "Mix-and-match bands with polished and textured finishes.",
    sizes: ["6", "7", "8", "9"],
    colors: [{ name: "Silver", hex: "#b0bec5" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "73",
    name: "Crystal Halo Tennis Bracelet",
    brand: "Givenchy",
    category: "Jewelry",
    price: 118.0,
    salePrice: 94.99,
    image: "https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400",
    rating: 4.6,
    reviews: 412,
    description: "Sterling silver bracelet with halo-set crystals and fold-over clasp.",
    sizes: ["7 in", "7.5 in", "8 in"],
    colors: [{ name: "Silver", hex: "#b0bec5" }],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "74",
    name: "Matte Black Signet Ring",
    brand: "Esquire Men's Jewelry",
    category: "Jewelry",
    price: 179.0,
    image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400",
    rating: 4.5,
    reviews: 203,
    description: "Ion-plated stainless steel with brushed matte finish.",
    sizes: ["9", "10", "11", "12"],
    colors: [{ name: "Black", hex: "#212121" }],
    inStock: true,
  },
  {
    id: "75",
    name: "Akoya Pearl Strand Necklace",
    brand: "Belle de Mer",
    category: "Jewelry",
    price: 299.0,
    image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=400",
    rating: 4.8,
    reviews: 341,
    description: "Lustrous Akoya cultured pearls with a secure 14K gold clasp.",
    sizes: ["16 in", "18 in"],
    colors: [{ name: "White Pearl", hex: "#fffde7" }],
    inStock: true,
    badge: "NEW",
  },

  // Beauty (+5)
  {
    id: "76",
    name: "Velvet Matte Lipstick Trio",
    brand: "MAC",
    category: "Beauty",
    price: 42.0,
    salePrice: 34.99,
    image: "https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=400",
    rating: 4.8,
    reviews: 1678,
    description: "Three iconic matte shades in a limited-edition gift set.",
    sizes: ["One Size"],
    colors: [],
    inStock: true,
    badge: "SALE",
  },
  {
    id: "77",
    name: "Rose Quartz Facial Roller",
    brand: "Skin Gym",
    category: "Beauty",
    price: 32.0,
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400",
    rating: 4.6,
    reviews: 923,
    description: "Cooling roller to help depuff and massage skincare in.",
    sizes: ["One Size"],
    colors: [],
    inStock: true,
    badge: "NEW",
  },
  {
    id: "78",
    name: "Glass Skin Serum Duo",
    brand: "Clinique",
    category: "Beauty",
    price: 72.0,
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400",
    rating: 4.7,
    reviews: 2145,
    description: "Hyaluronic duo for hydrated, radiant-looking skin.",
    sizes: ["30ml x2"],
    colors: [],
    inStock: true,
  },
  {
    id: "79",
    name: "Vitamin C Radiance Serum",
    brand: "Estée Lauder",
    category: "Beauty",
    price: 88.0,
    image: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=400",
    rating: 4.8,
    reviews: 2890,
    description: "Brightening serum with stabilized vitamin C.",
    sizes: ["30ml", "50ml"],
    colors: [],
    inStock: true,
    badge: "BEST SELLER",
  },
  {
    id: "80",
    name: "Hydrating Overnight Mask",
    brand: "Clinique",
    category: "Beauty",
    price: 38.0,
    image: "https://images.unsplash.com/photo-1612817288484-6f916006741a?w=400",
    rating: 4.5,
    reviews: 756,
    description: "Rich gel-cream mask that replenishes while you sleep.",
    sizes: ["75ml"],
    colors: [],
    inStock: true,
  },
];

export const categories = [
  { id: "women", name: "Women", image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400", count: 1255 },
  { id: "men", name: "Men", image: "https://images.unsplash.com/photo-1490578474895-699cd4e2cf59?w=400", count: 985 },
  { id: "kids", name: "Kids", image: "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=400", count: 655 },
  { id: "home", name: "Home", image: "https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=400", count: 1545 },
  { id: "shoes", name: "Shoes", image: "https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=400", count: 2105 },
  { id: "handbags", name: "Handbags", image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=400", count: 455 },
  { id: "jewelry", name: "Jewelry", image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400", count: 895 },
  { id: "beauty", name: "Beauty", image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400", count: 1785 },
];

export const navCategories = [
  { id: "women", name: "Women", subcategories: ["Dresses", "Tops", "Pants", "Jeans", "Coats", "Activewear"] },
  { id: "men", name: "Men", subcategories: ["Suits", "Shirts", "Pants", "Jeans", "Coats", "Activewear"] },
  { id: "kids", name: "Kids", subcategories: ["Girls", "Boys", "Baby", "Shoes", "Toys"] },
  { id: "home", name: "Home", subcategories: ["Bedding", "Bath", "Kitchen", "Furniture", "Decor"] },
  { id: "shoes", name: "Shoes", subcategories: ["Women's Shoes", "Men's Shoes", "Kids' Shoes", "Athletic"] },
  { id: "handbags", name: "Handbags", subcategories: ["Totes", "Crossbody", "Shoulder Bags", "Clutches"] },
  { id: "jewelry", name: "Jewelry", subcategories: ["Necklaces", "Earrings", "Bracelets", "Rings"] },
  { id: "beauty", name: "Beauty", subcategories: ["Skincare", "Makeup", "Fragrance", "Hair Care"] },
];
